function dynamicImageImporter(imageContext){
    const imageKeys = imageContext.keys();
    const images = imageContext.keys().map(image => imageContext(image));
    const imageMap = {};
    const regex = /\w+/;

    for(let i=0; i<imageKeys.length;i++){
        const key = imageKeys[i];
        // Remove ./ and .png,.jpg,.svg etc...
        const newKey = regex.exec(key).toString(); 
        imageMap[newKey] =  images[i];
    }

    return imageMap;
}

export default dynamicImageImporter;